import { CustomerDto } from "@/models/club";
import { ActionIcon, Avatar, Group, Paper, Stack, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";

type Props = {
  customer: CustomerDto;
  addCustomer: (phoneNumber: string) => void;
};

function SearchUserItem({ customer, addCustomer }: Props) {
  const handleSelect = () => {
    addCustomer(customer?.phoneNumber || "");
  };

  return (
    <Paper p="md" radius="md" withBorder>
      <Stack>
        <Group justify="space-between">
          <Group>
            <Avatar radius="xl" src={null} alt="no image here" />
            <Stack gap="0">
              <Text size="md">{customer.phoneNumber}</Text>
              {
                <Text size="xs" c="gray">{`${customer?.firstName || ""} ${
                  customer?.lastName || ""
                }`}</Text>
              }
            </Stack>
          </Group>
          <ActionIcon color="green" variant="filled" onClick={handleSelect}>
            <IconPlus />
          </ActionIcon>
        </Group>
      </Stack>
    </Paper>
  );
}

export default SearchUserItem;
